import { render } from "./10.FaqSection.vue?vue&type=template&id=af5ee778&scoped=true"
import script from "./10.FaqSection.vue?vue&type=script&lang=js"
export * from "./10.FaqSection.vue?vue&type=script&lang=js"

import "./10.FaqSection.vue?vue&type=style&index=0&id=af5ee778&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af5ee778"]])

export default __exports__